export default __webpack_public_path__ + "static/media/ag-icon-active.9894ad50.svg";